
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/other-resources",
      function () {
        return require("private-next-pages/other-resources.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/other-resources"])
      });
    }
  